import React from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy, MessageCircle, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PageHero } from '../components/shared/PageHero';
import { useSEO } from '../hooks/useSEO';

const supportCards = [
  {
    title: 'Hablar con el equipo',
    description: 'Resuelve dudas antes de comprar o pide ayuda para identificar tu modelo y su compatibilidad.',
    icon: MessageCircle,
    ctaLabel: 'Contactar',
    href: '/contacto'
  },
  {
    title: 'Accesorios y recambios',
    description: 'Entra en la guia oficial para orientarte antes de pasar a la tienda.',
    icon: Wrench,
    ctaLabel: 'Abrir guia',
    href: '/accesorios-recambios'
  },
  {
    title: 'Red oficial de SAT',
    description: 'Consulta el mapa multipunto y localiza tu servicio técnico autorizado más cercano con sus datos de contacto.',
    icon: LifeBuoy,
    ctaLabel: 'Ver red oficial',
    href: '/soporte/red-servicio-tecnico'
  }
];

export default function Support() {
  useSEO({
    title: 'Soporte Zwheel',
    description: 'Contacta con Zwheel, consulta la guia oficial de accesorios y recambios y localiza tu servicio técnico autorizado más cercano.',
    keywords: 'soporte Zwheel, servicio técnico Zwheel, contacto Zwheel, recambios compatibles, ayuda'
  });

  return (
    <div className="bg-white">
      <PageHero
        tag="Soporte oficial"
        title="Te ayudamos a encontrar la ruta correcta"
        subtitle="Antes de comprar un accesorio o un recambio, valida tu modelo y entra en la tienda por el camino adecuado."
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mb-12">
            <span className="text-sm font-bold tracking-[0.16em] uppercase text-primary block mb-3">
              Soporte
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Un punto de ayuda para compra, compatibilidad y contacto
            </h2>
            <p className="text-lg text-gray-600">
              Este espacio no sustituye a la tienda. Su funcion es orientarte para que compres el producto o la pieza correcta.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {supportCards.map((card) => (
              <div key={card.title} className="rounded-[2rem] border border-gray-200 bg-white p-7">
                <card.icon className="w-6 h-6 text-primary mb-5" />
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{card.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{card.description}</p>
                <Button asChild variant="outline">
                  <Link to={card.href}>{card.ctaLabel}</Link>
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
